import { Injectable } from '@angular/core';
import { BaseService } from '../shared/services/base.service';
import { AppService } from '../shared/services/app.service';
import { TranslateService } from './translate.service';
import { PreferenceService } from '../shared/services/preference.service';
import { AuthenticationService } from '../shared/services/authentication.service';
declare global {
    interface Window {
      Chart: any;
      ChartZoom: any;
      XLSX: any;
    }
  }
declare var streamSaver: any;
@Injectable({
    providedIn: 'root'
})
export class LazyService {
    public config: any = {};


    constructor(
        public baseService: BaseService, 
        public appService: AppService,
        private translateService:TranslateService,
        public auth:AuthenticationService,
        private preferenceService:PreferenceService) {
        this.config.aceLoaded = false;
    }

    loadLanguageFile(injector, callback) {        
        this.translateService.getLanguage(async (ln)=>{
            var base_ln;
            var local_ln_exist = ln.includes('-');
            if(local_ln_exist) base_ln = ln.split('-')[0]
            else  base_ln = ln;  
            return await import('src/assets/translations/'+base_ln+'.resource.json').then(m => {
                this.appService.setUpLanguageMap(ln,m);     
            })
            .then(async () => {
                if(local_ln_exist)
                    await this.appService.loadRootLocalLanguageFile(ln, callback); 
            })
            .then(() => {
                callback(true);
            })
            .catch((err) => {
                callback(true);
                //console.warn('main translation file not found for module ', err)
            });
        })
    }

    loadJosnModule(injector, callback) {
        var module;
        return import('src/modules/lazy-loaded/json/json.module').then(m => {
            return module = m.JsonModule;
        }).then(() => {
            new module(injector);
            callback();
        });
    }


    loadDynamicStyle(cssURL: string) {
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('link');
        style.id = 'css-styling';
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = `${cssURL}`;
        head.appendChild(style);
    }
    

    loadDecoratorModule(injector, callback) {
        var module;
        import('src/modules/lazy-loaded/decorator/decorator.module').then(m => {
            return module = m.DecoratorModule;
        }).then(() => {
            new module(injector);
            callback();
        });
    }

    loadAllLazyModules(injector, callback) {
        this.loadDecoratorModule(injector, () => { });
        this.loadChartJs();
        this.loadPDFLib();
        this.loadCKEditor();
        this.loadPlatformJs();
        this.loadStreamServer();
        this.loadLibphonenumber();
        this.loadAceditor(() => { });
        callback();
    }

    // loadChartJs() {
    //     import("src/assets/js/Chart.min.js");
    // }
    async loadChartJs() {
        try {
          await this.loadScript("/assets/js/Chart.min.js");
          // console.log(" Chart.js loaded");
          await this.loadScript("/assets/js/hammer.min.js");
          //console.log(" Hammer.js loaded");
          await this.loadScript("/assets/js/Chartjs-plugin-zoom.min.js");
          //console.log(" Chart.js Zoom plugin loaded");
          // Register the Zoom plugin if both Chart and Zoom exist
          if (window.Chart && window.ChartZoom) {
            window.Chart.register(window.ChartZoom);
           // console.log("✅ Chart.js and Zoom plugin registered successfully!");
          } else {
           // console.error("❌ Chart or ChartZoom not found.");
          }
        } catch (error) {
          console.error("❌ Error loading scripts:", error);
        }
      }
    loadPDFLib(){
        import("src/assets/js/pdf-lib.min.js");
    }
    loadPlatformJs() {
        import("src/assets/js/platform.min.js");
    }
    loadCKEditor() {
        import("node_modules/ckeditor4/ckeditor.js");
    }
    // loadLibphonenumber(){
    //     import("node_modules/libphonenumber-js");
    // }
    async loadLibphonenumber(): Promise<any> {
        if ((window as any).libphonenumber) {
         // console.log("📞 libphonenumber already loaded.");
          return (window as any).libphonenumber;
        }  
        await this.loadScript("/assets/js/libphonenumber-js.min.js", true);
      
        //console.log("📞 libphonenumber loaded!", (window as any).libphonenumber);
        return (window as any).libphonenumber;
      }

    //sheetjs is only needed by the screens that read xlsx/xls uploads - callers load it on demand and the guard keeps repeat calls cheap
    async loadXlsx(): Promise<any> {
        if (window.XLSX) {
            return window.XLSX;
        }
        await this.loadScript("/assets/js/xlsx.full.min.js");
        return window.XLSX;
    }

    loadStreamServer() {
        var promises = [];
        promises.push(this.loadScript("/assets/js/web-stream/ponyfill.min.js"));
        promises.push(this.loadScript("/assets/js/web-stream/StreamSaver.min.js"));
        Promise.all(promises).then((res) => {
            var defaultURL = "https://streamsaver.karexpert.com"
            var streamSaverObj = this.appService.getStreamSaver();
            if(streamSaverObj.indexOf("https")>-1){
                streamSaver.mitm = streamSaverObj;
            }else  if(window.location.hostname.indexOf("localhost")>-1){
                streamSaver.mitm =  defaultURL
            }
            else if(streamSaverObj == "subdomain"){
                streamSaver.mitm =  this.getStreamSaverUrl()
            }else{
                //default case
                streamSaver.mitm = defaultURL
            }

        });
    }

    getStreamSaverUrl() {
        const { protocol, hostname } = window.location;
      
        const parts = hostname.split('.');
      
        // If domain has subdomain(s), remove only the first one
        const baseDomain =
          parts.length > 2 ? parts.slice(1).join('.') : hostname;
      
        return `${protocol}//streamsaver.${baseDomain}`;
    }
    
    loadAccountConfig(){
        return this.baseService.get("GET_CONFIG", "module_code:system_config,config_code:system_config", "facility_config_mapping", "facility-management",undefined,undefined,{"cache":true}).toPromise()
        .then(
            res => {
                if (res.errCode == 0 && res.resource.length > 0) {
                    this.appService.parseAccountConfig(res.resource[0]);
                }
            }
        )
    }
    loadAccountValues(){
        return this.baseService.get("GET_CONFIG", "module_code:system_config,config_code:account_values", "facility_config_mapping", "facility-management",undefined,undefined,{"cache":true}).toPromise()
        .then(
            res => {
                if (res.errCode == 0 && res.resource.length > 0) {
                    this.appService.parseAccountConfig(res.resource[0]);
                }
            }
        )
    }

    loadAccountOnlyConfig(){
        return this.baseService.get("GET_CONFIG", "module_code:system_config,config_code:account_config", "facility_config_mapping", "facility-management",undefined,undefined,{"cache":true}).toPromise()
        .then(
            res => {
                if (res.errCode == 0 && res.resource.length > 0) {
                    this.appService.parseAccountConfig(res.resource[0]);
                }
            }
        )
    }


    loadAceditor(callback) {
        if (!this.config.aceLoaded) {
            var promises = [];
            promises.push(this.loadScript("/assets/js/ace/ace.js"));
            promises.push(this.loadScript("/assets/js/ace/ace-diff.min.js"));
            Promise.all(promises).then((res) => {
                this.config.aceLoaded = true;
                callback();
            });
        } else {
            callback();
        }
    }

    getFacilityListPromise() {
        let Obj = { query_id: "GET_ALL_FACILITIES", args: `status:active,account_id:${this.appService.getAppHeader().account_id},noCount:1`, projectionKeys: "id,name,primary_address,facility_short_name,status,telecom,facility_id,facility_name"}
        return this.baseService.getData(Obj, '', "organization", "facility-management").toPromise()
            .then(
                res => {
                    console.log("response is :: ",res);
                    if (res.errCode == 0 && res.resource.length > 0) {
                        this.appService.parseFaclityList(res);
                    }
                }
            )
    }
    loadScript(src: string,isModule=false) {
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            let script:any = document.createElement('script');
            if(isModule){
                script.type = 'module';
            }else{
                script.type = 'text/javascript';
            }
                script.src = src;
                if (script.readyState) {  //IE
                    script.onreadystatechange = () => {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            resolve({script: src, loaded: true, status: 'Loaded'});
                        }
                    };
                } else {  //Others
                    script.onload = () => {
                        resolve({script: src, loaded: true, status: 'Loaded'});
                    };
                }
                script.onerror = (error: any) => resolve({script: src, loaded: false, status: 'Loaded'});
                document.getElementsByTagName('head')[0].appendChild(script);
        });
    }


}